import { faCheckCircle, faFileAlt, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { MenuItem } from 'pages/home/models/types/home';

export const getNavbarMenuItemIcon = (item: MenuItem) => {
  if (item.titel === 'Rapportage') return faFileAlt;
  if (item.heeftWaarschuwing) return faExclamationTriangle;
  return item.isGereed ? faCheckCircle : faTimesCircle;
};

export const getNavbarMenuItemColor = (item: MenuItem): string => {
  if (item.heeftWaarschuwing) return '#D8620B';
  return item.isGereed ? '#00A241' : ' #00A1DF';
};

export const getMenuItemNavigationUrl = (menuUrl: string, kringloopwijzerId: string | null): string => {
  const pathname = new URL(menuUrl, window.location.origin).pathname.replace(/\/index\/?$/i, '');
  return `${pathname}/index/${kringloopwijzerId}`;
};

export const getRapportageColor = (item: { isGereed: boolean; isDisabled: boolean }): string => {
  if (item.isDisabled) return '#d3d3d3';
  return item.isGereed ? '#00A241' : ' #00A1DF';
};

//indienen:
//1:Concept
//2:Ingediend
//3:Definitief goedgekeurd
//4:Definitief afgekeurd
export const getIndienenColor = (kringloopwijzerStatusId: number, isDisabled: boolean): string => {
  if (isDisabled) return '#d3d3d3';
  switch (kringloopwijzerStatusId) {
    case 1:
      return '#00A1DF';
    case 2:
      return '#00A241';
    case 3:
      return '#d3d3d3';
    case 4:
      return '#d3d3d3';
    default:
      break;
  }
};

export const getIndienenText = (kringloopwijzerStatusId: number): string => {
  switch (kringloopwijzerStatusId) {
    case 1:
      return 'Indienen';
    case 2:
      return 'Ingediend';
    case 3:
      return 'Definitief';
    case 4:
      return 'Afgekeurd';
    default:
      break;
  }
};
